import { TransactionStatus } from "@/type/core/transaction/transaction.types";
import BasicButton from "@components/core/buttons/BasicButton";
import BasicModal from "@components/core/modals/BasicModal";
import { Input } from "antd";
import { Dispatch, FunctionComponent, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

interface AnnulationCauseModalProps {
  visible: boolean;
  onOk: (status: TransactionStatus, annulationCause: string) => void;
  onCancel: () => void;
  title: string;
  annulationCause: string;
  setAnnulationCause: Dispatch<SetStateAction<string>>;
  className?: string;
}

const AnnulationCauseModal: FunctionComponent<AnnulationCauseModalProps> = ({
  visible,
  onOk,
  onCancel,
  title,
  annulationCause,
  setAnnulationCause,
  className = "",
}) => {
  const { t } = useTranslation();

  return (
    <BasicModal
      visible={visible}
      onCancel={onCancel}
      title={title}
      closable={false}
      footer={
        <div className="modal-footer-buttons">
          <BasicButton
            variant="secondary"
            text={t("buttons.cancel")}
            onClick={onCancel}
          />
          <BasicButton
            variant="primary"
            text={t("buttons.validate")}
            onClick={() => onOk("canceled", annulationCause)}
          />
        </div>
      }
      className={`app-modal-action-cause ${className}`}
    >
      <div className="px-15">
        <label htmlFor="motif">{t("modal.reason")}</label>
        <Input.TextArea
          id="motif"
          value={annulationCause}
          onChange={(e) => setAnnulationCause(e.target.value)}
          maxLength={255}
          autoSize={{ minRows: 6, maxRows: 6 }}
        />
      </div>
    </BasicModal>
  );
};

export default AnnulationCauseModal;
